import React, { FC } from 'react';

interface HomeImageProps {
  src: string;
  width: string | number;
  height: string | number;
  alt: string;
}

const HomeImage: FC<HomeImageProps> = ({ src, alt, width, height }) => {
  return <img src={src} alt={alt} width={width} height={height} />;
};

export default HomeImage;
